export const filterOrdersForTodayDo = (orders, specificDate) => {
    const today = new Date(specificDate);
    today.setHours(0, 0, 0, 0);

    return orders.filter(order => {
        const livraisonDate = order.dateLivraison?.toDate();
        livraisonDate.setHours(0, 0, 0, 0);
        return livraisonDate.getTime() === today.getTime() && order.etat === 'valider';
    });
}